import React, { Fragment, useEffect } from 'react';

import { colors } from 'app/variables';

import StepHeading from './StepHeading';

function SignupFormStep4() {
  useEffect(() => {
    setTimeout(() => {
      const facilityId = window.resmioApp?.config?.['src/config']?.facility_id;
      if (facilityId) {
        window.location.href = `/${facilityId}/onboarding`;
      } else {
        window.location.href = '/';
      }
    }, 8000);
  }, []);
  return (
    <Fragment>
      <StepHeading>
        <span style={{ color: colors.java }}>
          {i18n.gettext('Yay!')}
          <br />
          {i18n.gettext('Your account has been created.')}
        </span>
      </StepHeading>
      <div style={{ textAlign: 'justify' }}>
        <div style={{ marginBottom: '2rem' }}>
          {i18n.gettext(
            'We have sent you an email to set up of your password.'
          )}
        </div>
        <div>
          {i18n.gettext(
            'In a few seconds you will be redirected to our system to start working with it!'
          )}
        </div>
      </div>
    </Fragment>
  );
}

export default SignupFormStep4;
